
const Languages = [
    {
        frensh                                  : "fr",
	
        english                                 : "en",
        

    },


];

export { Languages };